export default __webpack_public_path__ + "f8374ad613670cd1405b8cfa3992d655.png";